(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_bundle-description"] && !Shopify.designMode) return;
  try {
    (function () {
    function measure(wrap) {
      var body = wrap.querySelector('.bundle-desc__body');
      var btn = wrap.querySelector('.bundle-desc__toggle');
      if (!body || !btn) return;

      // Never re-clamp copy the shopper has opened: the late re-measure below runs
      // after fonts land, which can be after someone has already pressed the button.
      if (wrap.hasAttribute('data-bundle-desc-opened')) return;

      wrap.classList.add('is-collapsed');

      // scrollHeight is the full flow, clientHeight the clamped box. Equal, give or
      // take a rounding pixel, means nothing is hidden — so drop the clamp and the
      // toggle rather than offering to reveal nothing.
      if (body.scrollHeight <= body.clientHeight + 2) {
        wrap.classList.remove('is-collapsed');
        btn.hidden = true;
        return;
      }

      btn.hidden = false;
    }

    function init(root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll('.bundle-desc:not([data-bundle-desc-bound])').forEach(function (wrap) {
        var btn = wrap.querySelector('.bundle-desc__toggle');
        if (!btn) return;

        wrap.setAttribute('data-bundle-desc-bound', 'true');
        measure(wrap);

        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';

        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          wrap.setAttribute('data-bundle-desc-opened', 'true');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });

        // The first measurement is taken in whatever font the browser has at that
        // moment. A webfont swapping in afterwards changes the line count, which can
        // turn copy that fitted into copy that does not — so take it again once the
        // fonts the page asked for have actually arrived.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            measure(wrap);
          });
        }
      });
    }

    function onReady() {
      init(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (e) {
      init(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_pdp-addon-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    /**
     * PDP add-on builder.
     *
     * Collapsed accordion steps sit above the buy buttons so Add to cart stays
     * reachable no matter how many add-ons a step offers. Selections are folded
     * into the existing product form's submit, producing one /cart/add.js call
     * containing the main variant plus every chosen add-on.
     */
    // How long a recorded selection stays valid after the shopper submits.
    // Long enough for a slow cart/add round trip, short enough that it cannot
    // attach itself to some later, unrelated cart event.
    var PENDING_TTL = 15000;

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(
          cents / 100
        );
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function selectedCards(root) {
      return Array.prototype.slice.call(root.querySelectorAll('.card__input:checked'));
    }

    /** Variant list for a card, parsed once and cached on the script tag. */
    function variantsOf(card) {
      var el = card.querySelector('[data-role="variant-data"]');
      if (!el) return null;
      if (!el.parsed) {
        try {
          el.parsed = JSON.parse(el.textContent);
        } catch (e) {
          el.parsed = [];
        }
      }
      return el.parsed;
    }

    /**
     * The currently pressed value per option, keyed by the option's real index.
     *
     * Read off each chip's data-option-index rather than the row's position:
     * a row whose values collapse to one is not rendered at all, so DOM order
     * and option order are not the same thing. An option with no rendered row
     * stays null, which matches() then treats as "any".
     */
    function selectionOf(card, width) {
      var selection = [];
      for (var i = 0; i < width; i++) selection.push(null);

      card.querySelectorAll('.chip.is-active').forEach(function (chip) {
        var index = parseInt(chip.getAttribute('data-option-index'), 10);
        if (index >= 0 && index < width) selection[index] = chip.getAttribute('data-value');
      });
      return selection;
    }

    /** How many options the variant data actually carries. */
    function optionCount(variants) {
      return variants[0] && variants[0].options ? variants[0].options.length : 0;
    }

    function matches(variant, selection) {
      return selection.every(function (value, i) {
        return value === null || variant.options[i] === value;
      });
    }

    /**
     * Resolves a selection to a variant, preferring one that can be bought.
     *
     * The just-clicked option is treated as fixed: if the shopper picks a colour
     * that is sold out in their current size, the size moves rather than the
     * colour snapping back to where it was — the last thing they touched is the
     * thing they meant.
     */
    function resolveVariant(variants, selection, pinnedIndex) {
      var exact = variants.filter(function (v) {
        return matches(v, selection);
      });
      var buyable = exact.filter(function (v) {
        return v.available;
      });
      if (buyable.length) return buyable[0];

      // The exact combination is sold out. Before settling for it, let the
      // other rows move: a shopper who clicks "Maxi" while holding a Single
      // pack that Maxi does not stock should land on a Maxi they can buy, not
      // on a dead card. Only the option they touched is held fixed.
      if (pinnedIndex !== null && pinnedIndex !== undefined) {
        var pinned = selection.map(function (value, i) {
          return i === pinnedIndex ? value : null;
        });
        var alternative = variants.filter(function (v) {
          return v.available && matches(v, pinned);
        });
        if (alternative.length) return alternative[0];
      }

      if (exact.length) return exact[0];
      return variants[0] || null;
    }

    /** Presses the chips that spell out this variant's options. */
    function syncChips(card, variant) {
      card.querySelectorAll('.chip').forEach(function (chip) {
        var index = parseInt(chip.getAttribute('data-option-index'), 10);
        var active = variant && variant.options[index] === chip.getAttribute('data-value');
        chip.classList.toggle('is-active', !!active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    /** Pushes a variant's price and thumbnail onto its card. */
    function applyVariant(card, variant, currency) {
      if (!variant) return;
      var input = card.querySelector('.card__input');

      input.value = variant.id;
      input.setAttribute('data-price', variant.price);

      var price = card.querySelector('[data-role="price"]');
      if (price) price.textContent = money(variant.price, currency);

      var compare = card.querySelector('[data-role="compare"]');
      if (compare) {
        var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.textContent = showCompare ? money(variant.compare_at_price, currency) : '';
        compare.hidden = !showCompare;
      }

      var thumb = card.querySelector('[data-role="thumb"]');
      var image = variant.featured_image && variant.featured_image.src;
      if (image && thumb) {
        thumb.src = image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      }
    }

    function normalize(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }

    // The joiners colour names are built from: "Honey and Performance Sand
    // Eco-Weave", "Ivory Boucle with Light Wood Base", "Washed Natural / Black".
    // Word joiners and dashes need a space on both sides, so "0-3M" and
    // "Eco-Weave" stay whole. A slash splits with or without spaces
    // ("White/Gray" casters, "Taupe/Ash" crib) unless a digit follows, so
    // sizes like "1/2" and "0-3M/3-6M" stay whole. Lookahead only: a
    // lookbehind is a parse error on older Safari and would take down every
    // block script with it.
    var JOINERS = / (?:&|and|\+|with|-) |\s*\/(?!\d)\s*|, /;

    /** The colour's parts, in any order: "black|washed natural". */
    function partsOf(value) {
      return normalize(value).split(JOINERS).sort().join('|');
    }

    /** The colour it leads with: "honey" for "Honey and Performance Sand Eco-Weave". */
    function leadOf(value) {
      return normalize(value).split(JOINERS)[0];
    }

    /**
     * How well an add-on's option value matches the main product: 4 the same
     * value, 3 the same parts in another order ("Black / Washed Natural" for
     * "Washed Natural / Black"), 2 the colour one of them leads with (the
     * "Honey" bookcase for the "Honey and Performance Sand Eco-Weave" crib,
     * and the other way round), 1 a colour named anywhere in the other (the
     * "White/Gray" casters for the Gray sleeper), 0 no match.
     */
    function matchScore(value, wanted) {
      var own = normalize(value);
      if (wanted.values.indexOf(own) !== -1) return 4;
      if (wanted.parts.indexOf(partsOf(value)) !== -1) return 3;
      if (wanted.leads.indexOf(own) !== -1 || wanted.values.indexOf(leadOf(value)) !== -1) return 2;
      if (wanted.pieces.indexOf(own) !== -1) return 1;
      var pieces = own.split(JOINERS);
      for (var i = 0; i < pieces.length; i++) {
        if (wanted.values.indexOf(pieces[i]) !== -1) return 1;
      }
      return 0;
    }

    /**
     * Moves each add-on onto the option values the main product is showing:
     * an Untreated bassinet pulls the Untreated conversion kit and mobile
     * holder, a Blonde crib the Blonde dresser.
     *
     * Matched by value, not option name, so "Color" on one product and
     * "Finish" on another still line up. A combined-listing child's family
     * value counts too: the Ash Caravan crib (variants Oiled / Raw) pulls the
     * Ash conversion kit. A name that only partly lines up still counts (see
     * matchScore), and the closest value on each row wins, the first chip on
     * a tie. Only values the add-on has a chip for
     * count, and chips exist only for in-stock values, so an add-on that does
     * not stock the main product's colour is left where it was rather than
     * pushed onto something unbuyable. Nothing is checked or unchecked: an
     * add-on the shopper already picked stays picked, on the matching variant.
     */
    function followPrimary(root) {
      var values;
      try {
        values = JSON.parse(root.getAttribute('data-primary-options') || '[]').concat(
          JSON.parse(root.getAttribute('data-family-options') || '[]')
        );
      } catch (e) {
        return;
      }
      if (!values.length) return;
      var wanted = {
        values: values.map(normalize),
        parts: values.map(partsOf),
        leads: values.map(leadOf),
        pieces: values.reduce(function (all, value) {
          return all.concat(normalize(value).split(JOINERS));
        }, []),
      };
      var currency = root.getAttribute('data-currency');

      root.querySelectorAll('[data-role="card"]').forEach(function (card) {
        var variants = variantsOf(card);
        if (!variants || !variants.length) return;

        var selection = selectionOf(card, optionCount(variants));
        var scores = {};
        var pinned = null;
        card.querySelectorAll('.chip').forEach(function (chip) {
          var index = parseInt(chip.getAttribute('data-option-index'), 10);
          var score = matchScore(chip.getAttribute('data-value'), wanted);
          if (!score || score <= (scores[index] || 0)) return;
          scores[index] = score;
          selection[index] = chip.getAttribute('data-value');
          if (pinned === null) pinned = index;
        });
        if (pinned === null) return;

        var variant = resolveVariant(variants, selection, pinned);
        if (!variant || String(variant.id) === card.querySelector('.card__input').value) return;
        syncChips(card, variant);
        applyVariant(card, variant, currency);
      });

      refresh(root);
    }

    /** Handles a click on one option value. */
    function applyChip(chip, currency) {
      var card = chip.closest('[data-role="card"]');
      var variants = variantsOf(card);
      if (!variants || !variants.length) return null;

      var index = parseInt(chip.getAttribute('data-option-index'), 10);
      var selection = selectionOf(card, optionCount(variants));
      selection[index] = chip.getAttribute('data-value');

      var variant = resolveVariant(variants, selection, index);
      syncChips(card, variant);
      applyVariant(card, variant, currency);
      return variant;
    }

    /**
     * Sets an input's checked state and announces it.
     *
     * Assigning `.checked` in script never fires `change`, so it is dispatched
     * by hand. Radios are grouped by name at document scope here (the block
     * sits outside the product form), so siblings are cleared explicitly rather
     * than relying on native grouping.
     */
    function select(input, checked) {
      if (input.type === 'radio' && checked) {
        var group = input.closest('.addons__step').querySelectorAll('.card__input');
        group.forEach(function (other) {
          if (other !== input) other.checked = false;
        });
      }
      input.checked = checked;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /** Summarises each step in its collapsed header, and totals the whole build. */
    function refresh(root) {
      var base = parseInt(root.getAttribute('data-base-price'), 10) || 0;
      var currency = root.getAttribute('data-currency');
      var total = base;
      var count = 0;

      root.querySelectorAll('.addons__step').forEach(function (step) {
        var picked = Array.prototype.slice.call(step.querySelectorAll('.card__input:checked'));
        var state = step.querySelector('[data-role="state"]');

        picked.forEach(function (input) {
          total += parseInt(input.getAttribute('data-price'), 10) || 0;
        });
        count += picked.length;

        if (picked.length === 0) {
          state.textContent = step.hasAttribute('data-required') ? 'Select' : '';
          state.classList.remove('is-filled');
        } else if (picked.length === 1) {
          state.textContent = picked[0].getAttribute('data-name');
          state.classList.add('is-filled');
        } else {
          state.textContent = picked.length + ' selected';
          state.classList.add('is-filled');
        }
      });

      var row = root.querySelector('[data-role="total-row"]');
      row.hidden = count === 0;
      root.querySelector('[data-role="count"]').textContent = count === 0 ? '' : '(' + (count + 1) + ' items)';
      root.querySelector('[data-role="total"]').textContent = money(total, currency);
    }

    function firstUnmetStep(root) {
      var steps = root.querySelectorAll('.addons__step[data-required]');
      for (var i = 0; i < steps.length; i++) {
        if (!steps[i].querySelector('.card__input:checked')) return steps[i];
      }
      return null;
    }

    /**
     * Adds the selected add-ons, and only after the main item is in the cart.
     *
     * The theme owns the main product's add-to-cart and cannot be pre-empted:
     * its delegated handler is bound to `document` in the CAPTURE phase (see
     * assets/component.js), so it always runs before any listener bound here,
     * whatever phase or element they use. An earlier version intercepted the
     * submit and posted the main variant plus the add-ons, which meant the
     * theme had already added the main item — landing it in the cart twice.
     *
     * So the submit is still left alone, but this no longer fires alongside it.
     * Racing the theme broke in both directions:
     *
     *   - The theme's CartAddEvent carries section HTML rendered during ITS
     *     add, i.e. a cart without the extras. It morphs the drawer whenever it
     *     lands last, painting over a correct render with a stale one — the
     *     shopper sees only the main item and assumes the add-ons were dropped.
     *   - The theme refuses the add outright on a 422 (stock cap, quantity
     *     rule) or a disabled button, and adds nothing. Firing regardless left
     *     the extras in the cart with no product to go with them.
     *
     * Waiting for the theme's own success event fixes both: nothing is added
     * unless the main item made it, and the re-render below is guaranteed to be
     * the last one. It carries no `sections`, which makes cart-items-component
     * re-render from the server (see its #handleCartUpdate) rather than from
     * HTML captured before the extras existed.
     */
    async function addExtras(root, items) {
      if (!items || !items.length) return;

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
        if (!res.ok) {
          var problem = await res.json().catch(function () {
            return null;
          });
          throw new Error((problem && (problem.description || problem.message)) || 'cart/add failed: ' + res.status);
        }

        var cart = null;
        var fresh = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (fresh.ok) cart = await fresh.json();

        // Clearing the selection stops a second Add to cart silently doubling
        // every add-on the shopper already bought.
        clearSelection(root);
        showError(root, null);

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'pdp-addon-builder',
              data: {
                source: 'pdp-addon-builder',
                // Not `item_count` — a bundle is several cart lines but one item
                // in the bubble. This is a classic script, so it reads the copy
                // assets/cart-count.js hangs off `Theme`.
                itemCount:
                  cart && (typeof Theme !== 'undefined' && Theme.cartDisplayCount
                    ? Theme.cartDisplayCount(cart)
                    : cart.item_count),
              },
            },
          })
        );
      } catch (err) {
        // Silence here is what made this hard to diagnose: the main item lands,
        // the extras do not, and nothing anywhere says so.
        showError(root, err && err.message ? err.message : 'Your add-ons could not be added.');
        console.error('[addons]', err);
      }
    }

    /** Unchecks every add-on and resets the running total. */
    function clearSelection(root) {
      root.querySelectorAll('.card__input:checked').forEach(function (input) {
        input.checked = false;
      });
      refresh(root);
    }

    function showError(root, message) {
      var box = root.querySelector('[data-role="error"]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
    }

    /**
     * Everything below is delegated from `document` and resolves its elements
     * per event. Nothing holds a node reference between events, and nothing
     * records state in an attribute.
     *
     * Both matter on a combined listing. Choosing another model navigates to a
     * sibling product and the theme morphs the page in place: the `.addons`
     * element survives, but its attributes are overwritten from the new markup
     * — wiping the "already bound" flag — while the <form> is replaced by a
     * different node. A listener bound to the old form still exists, attached
     * to nothing the shopper can reach, so the add-ons were recorded nowhere
     * and only the bassinet reached the cart.
     */
    function sectionRootFor(node) {
      if (!node || !node.closest) return null;
      var section = node.closest('.shopify-section');
      return section ? section.querySelector('.addons') : null;
    }

    /** Resolved fresh every time, because the form node does not survive. */
    function formFor(root) {
      var form = document.getElementById(root.getAttribute('data-form-id'));
      if (form) return form;
      var section = root.closest('.shopify-section') || document;
      return section.querySelector('form[data-type="add-to-cart-form"]');
    }

    function keyFor(root) {
      return root.getAttribute('data-section-id') || 'addons';
    }

    /** What the shopper chose, held only between submit and the theme's reply. */
    var pending = {};

    /**
     * Presses chips for the shown variant when Liquid could not, then lines the
     * add-ons up with the main variant the page opened on (a ?variant= link).
     */
    function syncInitialCards(scope) {
      (scope || document).querySelectorAll('.addons [data-role="card"]').forEach(function (card) {
        var variants = variantsOf(card);
        if (!variants || !variants.length) return;
        if (card.querySelector('.chip.is-active')) return;
        var root = card.closest('.addons');
        var current = resolveVariant(variants, selectionOf(card, optionCount(variants)), null);
        syncChips(card, current);
        applyVariant(card, current, root && root.getAttribute('data-currency'));
      });
      (scope || document).querySelectorAll('.addons').forEach(followPrimary);
    }

    document.addEventListener('click', function (event) {
      // Required steps gate the button rather than the submit: cancelling the
      // click stops the form ever submitting, which is the one reliable way to
      // hold back a handler bound to document in capture. Buy now is gated the
      // same way — it skips the cart entirely, so an unmet step there would go
      // straight to checkout without the item the shopper had to choose.
      var addButton = event.target.closest && event.target.closest('[name="add"], [data-custom-buy-now]');
      if (addButton) {
        var gateRoot = sectionRootFor(addButton);
        if (gateRoot) {
          var unmet = firstUnmetStep(gateRoot);
          if (unmet) {
            event.preventDefault();
            unmet.open = true;
            unmet.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      var card = event.target.closest && event.target.closest('[data-role="card"]');
      if (!card) return;
      var root = card.closest('.addons');
      if (!root) return;

      var input = card.querySelector('.card__input');
      if (!input || input.disabled) return;

      var chip = event.target.closest('.chip');
      if (chip) {
        var variant = applyChip(chip, root.getAttribute('data-currency'));
        // Picking a variant implies wanting the item — unless the shopper
        // landed on a combination that cannot be bought.
        if (variant && variant.available) select(input, true);
        return;
      }

      // Let the PDP link do its own job.
      if (event.target.closest('a')) return;

      // The input is visually hidden, so a click that lands on it came from
      // assistive tech or a keyboard activation — it has already toggled itself
      // and fired change.
      if (event.target === input) return;

      if (input.type === 'checkbox') {
        select(input, !input.checked);
        return;
      }

      // A radio cannot be unchecked natively, so an optional single-select step
      // would trap the shopper into a choice. Clicking the chosen card again
      // clears it.
      var optional = !card.closest('.addons__step').hasAttribute('data-required');
      select(input, !(input.checked && optional));
    });

    document.addEventListener('change', function (event) {
      var root = event.target.closest && event.target.closest('.addons');
      if (root) refresh(root);
    });

    // The main picker announces every variant change, after its morph. A
    // same-product switch morphs only the picker, so this block's main-variant
    // attributes are stale until updated here — the base price in the running
    // total included. A combined-listing switch has already morphed this block
    // with the sibling's markup, which renders every add-on at its first
    // available variant. Either way, the add-ons then follow the main variant.
    document.addEventListener('variant:update', function (event) {
      var root = sectionRootFor(event.target);
      if (!root) return;

      var detail = event.detail || {};
      var variant = detail.resource;
      // Quick-add and product-card pickers dispatch this too. Only the product
      // this block was rendered for counts.
      var productId = detail.data && detail.data.productId;
      if (!variant || !variant.options || String(productId) !== root.getAttribute('data-product-id')) return;

      root.setAttribute('data-primary-options', JSON.stringify(variant.options));
      if (variant.price != null) root.setAttribute('data-base-price', variant.price);
      followPrimary(root);
    });

    // The submit is not intercepted — see addExtras. It only records what the
    // shopper chose; the add itself waits for the theme to confirm the main
    // item went in. The window matters: without it, any later cart activity on
    // the page (wishlist, save-for-later, a quick-add card) would look like the
    // shopper's Add to cart and re-add the extras.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var root = sectionRootFor(form);
      if (!root || formFor(root) !== form) return;
      if (firstUnmetStep(root)) return;

      var picked = selectedCards(root);
      if (!picked.length) return;

      pending[keyFor(root)] = {
        items: picked.map(function (input) {
          return { id: Number(input.value), quantity: 1 };
        }),
        expires: Date.now() + PENDING_TTL,
      };
    });

    // The PDP form is one of many product-form-components on the page — every
    // recommendation card is another. The dispatching component is what tells
    // the shopper's Add to cart apart from a quick-add three sections down.
    document.addEventListener('cart:update', function (event) {
      var component = event.target;
      if (!component || !component.tagName) return;
      if (component.tagName.toLowerCase() !== 'product-form-component') return;

      var root = sectionRootFor(component);
      if (!root) return;

      var key = keyFor(root);
      var queued = pending[key];
      if (!queued) return;
      delete pending[key];

      var data = (event.detail && event.detail.data) || {};
      if (data.source === 'pdp-addon-builder') return;

      // The theme reports a refused add (422 stock cap, quantity rule) as a
      // cart:update carrying didError rather than as a thrown error. Saying so
      // matters: this PDP renders no error element of the theme's own, so a
      // refusal is otherwise completely silent and reads as a dead button.
      if (data.didError) {
        showError(root, 'That item could not be added, so your add-ons were left out too.');
        return;
      }
      if (Date.now() > queued.expires) return;

      addExtras(root, queued.items);
    });

    // A hard failure clears the intent too, so it cannot fire late against a
    // cart the shopper has since changed.
    document.addEventListener('cart:error', function (event) {
      var root = sectionRootFor(event.target);
      if (!root) return;
      delete pending[keyFor(root)];
      var data = (event.detail && event.detail.data) || {};
      showError(root, data.message || data.description || 'That item could not be added, so your add-ons were left out too.');
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncInitialCards(document);
      });
    } else {
      syncInitialCards(document);
    }

    document.addEventListener('shopify:block:load', function (event) {
      syncInitialCards(event.target);
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-brand-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpBrandBadgeDialogBound) return;
    window.__pdpBrandBadgeDialogBound = true;
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-brand-badge-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('data-brand-badge-open'));
        if (dlg && typeof dlg.showModal === 'function') {
          event.preventDefault();
          dlg.showModal();
        }
        return;
      }
      if (event.target.closest('[data-brand-badge-close]')) {
        var open = event.target.closest('dialog');
        if (open) open.close();
        return;
      }
      // A click on the backdrop lands on the dialog itself: its content is all in __inner.
      if (event.target.matches && event.target.matches('dialog.pdp-brand-badge-dialog')) {
        event.target.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-description-collapsible"] && !Shopify.designMode) return;
  try {
    (function () {
    function initDescToggle(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-desc-wrap--collapsible:not([data-desc-bound])').forEach(function (wrap) {
        var btn = wrap.querySelector('.pdp-desc-toggle');
        if (!btn) return;

        var p = wrap.querySelector('.pdp-desc-text');
        if (!p) return;

        // Only show the toggle if the text actually overflows 3 lines
        function checkOverflow() {
          // temporarily uncollapse to measure full height
          wrap.classList.remove('is-collapsed');
          var fullH = p.scrollHeight;
          wrap.classList.add('is-collapsed');
          var clampedH = p.offsetHeight;

          if (fullH <= clampedH + 2) {
            // no overflow — remove collapsible behaviour entirely
            wrap.classList.remove('pdp-desc-wrap--collapsible', 'is-collapsed');
            btn.style.display = 'none';
            return;
          }
          btn.style.display = '';
        }

        checkOverflow();

        wrap.setAttribute('data-desc-bound', 'true');

        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';

        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function onReady() { initDescToggle(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (e) {
      initDescToggle(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-info-sections"] && !Shopify.designMode) return;
  try {
    (function () {
    function initInfoToggles(root) {
      if (!root || !root.querySelectorAll) return;
      root
        .querySelectorAll('.pdp-stacked-info .pdp-stacked-info--collapsible:not([data-info-bound])')
        .forEach(function (wrap) {
          wrap.setAttribute('data-info-bound', 'true');
          var btn = wrap.querySelector('.pdp-stacked__toggle');
          if (!btn) return;
          var more = btn.getAttribute('data-label-more') || 'Show more';
          var less = btn.getAttribute('data-label-less') || 'Show less';
          btn.addEventListener('click', function () {
            var collapsed = wrap.classList.toggle('is-collapsed');
            btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
            btn.textContent = collapsed ? more : less;
          });
        });
    }

    function onReady() {
      initInfoToggles(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initInfoToggles(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-key-features"] && !Shopify.designMode) return;
  try {
    (function () {
    function initKeyFeaturesToggle(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-stacked-key-features .pdp-stacked-kf--collapsible:not([data-kf-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-kf-bound', 'true');
        var btn = wrap.querySelector('.pdp-stacked__toggle');
        if (!btn) return;
        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function onReady() { initKeyFeaturesToggle(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initKeyFeaturesToggle(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-pros-cons"] && !Shopify.designMode) return;
  try {
    (function () {
    function initProsConsToggle(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-stacked-pros-cons .pdp-stacked-pc--collapsible:not([data-pc-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-pc-bound', 'true');
        var btn = wrap.querySelector('.pdp-stacked__toggle');
        if (!btn) return;
        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function onReady() { initProsConsToggle(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initProsConsToggle(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSizeGuide(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('[data-psg-open]').forEach(function (btn) {
        if (btn.dataset.psgBound) return;
        btn.dataset.psgBound = '1';
        var dialog = document.getElementById(btn.dataset.psgOpen);
        if (!dialog) return;
        btn.addEventListener('click', function () { dialog.showModal(); });
        dialog.addEventListener('click', function (e) {
          // click on the backdrop (the dialog element itself) closes
          if (e.target === dialog || e.target.closest('[data-psg-close]')) dialog.close();
        });
      });
    }

    function onReady() { initSizeGuide(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initSizeGuide(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-specifications"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSpecsToggle(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.pdp-stacked-specifications .pdp-stacked-spec--collapsible:not([data-spec-bound])').forEach(function (wrap) {
        wrap.setAttribute('data-spec-bound', 'true');
        var btn = wrap.querySelector('.pdp-stacked__toggle');
        if (!btn) return;
        var more = btn.getAttribute('data-label-more') || 'Show more';
        var less = btn.getAttribute('data-label-less') || 'Show less';
        btn.addEventListener('click', function () {
          var collapsed = wrap.classList.toggle('is-collapsed');
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
          btn.textContent = collapsed ? more : less;
        });
      });
    }

    function onReady() { initSpecsToggle(document); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initSpecsToggle(event.target);
    });

    // Mirrors snippets/pdp-variant-gtin.liquid: only a real GTIN (8/12/13/14 digits, valid
    // GS1 check digit) is shown, so vendor-internal codes in the barcode field stay hidden.
    function gtinFromBarcode(barcode) {
      var code = String(barcode || '').replace(/[\s-]/g, '');
      var label = { 8: 'GTIN', 12: 'UPC', 13: 'EAN', 14: 'GTIN' }[code.length];
      if (!label || !/^\d+$/.test(code)) return null;
      var sum = 0;
      for (var i = 0; i < code.length - 1; i++) {
        var fromRight = code.length - 2 - i;
        sum += Number(code[i]) * (fromRight % 2 === 0 ? 3 : 1);
      }
      if ((10 - (sum % 10)) % 10 !== Number(code[code.length - 1])) return null;
      return { label: label, code: code };
    }

    function setRow(row, value, label) {
      if (!row) return false;
      var valueEl = row.querySelector('[data-variant-id-value]');
      var labelEl = row.querySelector('[data-variant-id-label]');
      if (valueEl) valueEl.textContent = value || '';
      if (labelEl && label) labelEl.textContent = label;
      row.hidden = !value;
      return Boolean(value);
    }

    // A same-product switch only morphs the picker, so the rows are updated from the variant
    // JSON here. A combined-listing switch re-renders the section server-side; this then just
    // re-applies the same values.
    document.addEventListener('variant:update', function (event) {
      var variant = event.detail && event.detail.resource;
      if (!variant || !(event.target instanceof Element)) return;
      var scope = event.target.closest('[id*="ProductInformation-"]');
      if (!scope) return;
      var data = event.detail.data || {};
      var productId = data.newProduct ? String(data.newProduct.id) : String(data.productId || '');
      scope.querySelectorAll('.pdp-stacked-specifications[data-product-id]').forEach(function (block) {
        if (productId && block.getAttribute('data-product-id') !== productId) return;
        var list = block.querySelector('.pdp-stacked-spec__list');
        var skuRow = block.querySelector('[data-variant-id-row="sku"]');
        var gtinRow = block.querySelector('[data-variant-id-row="gtin"]');
        if (!list || (!skuRow && !gtinRow)) return;
        var gtin = gtinFromBarcode(variant.barcode);
        setRow(skuRow, String(variant.sku || '').trim());
        setRow(gtinRow, gtin && gtin.code, gtin && gtin.label);

        // Keep SKU before GTIN, and any hidden row after both, so nth-child collapse counts
        // only visible rows.
        [skuRow, gtinRow].forEach(function (row) { if (row && !row.hidden) list.appendChild(row); });
        [skuRow, gtinRow].forEach(function (row) { if (row && row.hidden) list.appendChild(row); });

        var visible = list.querySelectorAll('.pdp-stacked-spec__item:not([hidden])').length;
        block.hidden = visible === 0;
        var wrap = block.querySelector('.pdp-stacked-spec--collapsible');
        var btn = block.querySelector('.pdp-stacked__toggle');
        if (!wrap || !btn) return;
        var needsToggle = visible > 3;
        if (needsToggle === !btn.hidden) return;
        // Crossing the 3-row line resets to collapsed, the same state a fresh page load shows.
        btn.hidden = !needsToggle;
        wrap.classList.toggle('is-collapsed', needsToggle);
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = btn.getAttribute('data-label-more') || 'Show more';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pack-contents"] && !Shopify.designMode) return;
  try {
    (function () {
    function escapeRows(list, rows) {
      list.textContent = '';
      (rows || []).forEach(function (row) {
        var wrap = document.createElement('div');
        wrap.className = 'pdp-pack-contents__row';
        var value = document.createElement('span');
        value.className = 'pdp-pack-contents__value';
        value.textContent = row.value != null ? String(row.value) : '';
        var label = document.createElement('span');
        label.className = 'pdp-pack-contents__label';
        label.textContent = row.label != null ? String(row.label) : '';
        wrap.appendChild(value);
        wrap.appendChild(label);
        list.appendChild(wrap);
      });
    }

    function initPackContents(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('[data-pack-contents]:not([data-pack-bound])').forEach(function (card) {
        card.setAttribute('data-pack-bound', 'true');
        var list = card.querySelector('[data-pack-list]');
        var script = card.querySelector('script[data-pack-map]');
        if (!list || !script) return;

        var map;
        try {
          map = JSON.parse(script.textContent);
        } catch (e) {
          return;
        }

        var section = card.closest('.shopify-section, dialog') || document;
        section.addEventListener('variant:update', function (event) {
          var id = event.detail && event.detail.resource && event.detail.resource.id;
          if (id == null) return;
          var rows = map[String(id)];
          if (!rows || !rows.length) {
            card.setAttribute('hidden', '');
            return;
          }
          card.removeAttribute('hidden');
          escapeRows(list, rows);
        });
      });
    }

    function onReady() {
      initPackContents(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }

    document.addEventListener('shopify:block:load', function (event) {
      initPackContents(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
